/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TrackingShipmentState = {
    Draft: 'draft',
    Quoted: 'quoted',
    QuoteSelected: 'quote_selected',
    Booked: 'booked',
    ReviewPriorBooking: 'review_prior_booking'
} as const;
export type TrackingShipmentState = typeof TrackingShipmentState[keyof typeof TrackingShipmentState];


export function instanceOfTrackingShipmentState(value: any): boolean {
    for (const key in TrackingShipmentState) {
        if (Object.prototype.hasOwnProperty.call(TrackingShipmentState, key)) {
            if (TrackingShipmentState[key as keyof typeof TrackingShipmentState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrackingShipmentStateFromJSON(json: any): TrackingShipmentState {
    return TrackingShipmentStateFromJSONTyped(json, false);
}

export function TrackingShipmentStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingShipmentState {
    return json as TrackingShipmentState;
}

export function TrackingShipmentStateToJSON(value?: TrackingShipmentState | null): any {
    return value as any;
}

export function TrackingShipmentStateToJSONTyped(value: any, ignoreDiscriminator: boolean): TrackingShipmentState {
    return value as TrackingShipmentState;
}

